import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from '@components/user/login/login.component';
import {SamlLoginComponent} from '@components/user/saml-login/saml-login.component';
import {AgreementComponent} from '@components/user/agreement/agreement.component';
import {EditProfileComponent} from '@components/user/edit-profile/edit-profile.component';
import {SharedModule} from '@shared/shared.module';
import {ChangePasswordComponent} from '@components/user/edit-profile/modal/change-password/change-password.component';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {PasswordResetComponent} from '@components/user/password-reset/password-reset.component';

@NgModule({
  declarations: [
    LoginComponent,
    AgreementComponent,
    SamlLoginComponent,
    EditProfileComponent,
    ChangePasswordComponent,
    PasswordResetComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    NgbModule
  ],
  exports: [
    LoginComponent,
    AgreementComponent,
    SamlLoginComponent,
  ]
})
export class UserModule {
}
